import request from '@/utils/request'

export function getGoodsList (payload) {
  return request({
    url: '/api/seller/goodsList',
    method: 'post',
    data: {
      is_on_sale: payload.isOnSale,
      keyword: payload.keyword,
      page: payload.page
    }
  })
}

export function getGoodsInfo (goodsId) {
  return request({
    url: '/api/seller/showGoods',
    method: 'post',
    data: {
      goods_id: goodsId
    }
  })
}
export function goodsEdit (data) {
  return request({
    url: '/api/seller/editGoods',
    method: 'post',
    data: {
      data
    }
  })
}



// WEBPACK FOOTER //
// ./src/api/goods.js